import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

import engine from '../Support/Engine';

import StandardField from '../UI/StandardField';
import Processing from '../UI/Processing';

class PasswordForm extends Component {

	state = {
		step: 1,
		form1: {
			email: {
				name: 'Email Address',
				kind: 'email',
				error: false,
				errormsg: '',
				value: ''
			}
		},
		form2: {
			code: {
				name: 'Reset Code',
				kind: 'text',
				error: false,
				errormsg: '',
				value: ''
			},
			password: {
				name: 'New Password',
				kind: 'password',
				error: false,
				errormsg: '',
				value: ''
			},
			password_confirm: {
				name: 'Confirm New Password',
				kind: 'password',
				error: false,
				errormsg: '',
				value: ''
			}
		},
		processing: false,
		haserror: false,
		result: 0,
		message: ''
	}


	steFieldChanged1 = (event, field) => {

		const updatedForm = {
			...this.state.form1
		};

		const updatedElement = {
			...this.state.form1[field]
		};

		updatedElement.value = event.target.value;
		updatedForm[field] = updatedElement;

		this.setState({form1: updatedForm});

	}

	steFieldChanged2 = (event, field) => {

		const updatedForm = {
			...this.state.form2
		};

		const updatedElement = {
			...this.state.form2[field]
		};

		updatedElement.value = event.target.value;
		updatedForm[field] = updatedElement;

		this.setState({form2: updatedForm});

	}


	steKeyboardAction = (event, field) => {
		if(event.key === 'Enter')
			this.submit();
	}


	submit = () => {

		const updatedState = {
			...this.state,
			processing: true,
			result: 0,
			haserror: false,
			message: ''
		};

		this.setState(updatedState);

		if(this.state.step === 1) {

			const email_regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			const updatedForm = {
				...this.state.form1
			};

			const updatedField = {
				...this.state.form1.email,
				error: false,
				errormsg: ''
			};

			if(!email_regex.test(updatedField.value)) {
				updatedField.error = true;
				updatedField.errormsg = 'Please enter a valid email address';
				updatedState.haserror = true;
			}

			updatedForm['email'] = updatedField;
			updatedState.form1 = updatedForm;
			this.setState(updatedState);

			if(updatedState.haserror) {
				updatedState.processing = false;
				this.setState(updatedState);
				return false;
			}

			engine.post('/account/reset-password/', {step: 1, email: this.state.form1.email.value})
				.then(packet => {
					if(packet.data.result) {
						this.setState({...this.state, processing: false, step: 2});
					}
					else {
						this.setState({...this.state, processing: false, result: -1, message: packet.data.response});
					}
				})
				.catch(error => {
					console.log(error);
					this.setState({...this.state, processing: false, result: -1, message: 'Sorry, an unexpected error occured.'});
				});

		}
		else if(this.state.step === 2) {

			for(let f in this.state.form2) {

				const updatedField = {
					...this.state.form2[f],
					error: false,
					errormsg: ''
				};

				switch(f) {
					case 'password':
						if(updatedField.value.length < 6) {
							updatedField.error = true;
							updatedField.errormsg = 'Please enter a password with at least 6 characters';
							updatedState.haserror = true;
						}
						break;
					case 'password_confirm':
						if(updatedField.value !== updatedState.form2.password.value) {
							updatedField.error = true;
							updatedField.errormsg = 'Passwords do not match';
							updatedState.haserror = true;
						}
						break;
					default:
						if(updatedField.value === '') {
							updatedField.error = true;
							updatedField.errormsg = 'Please enter a ' + updatedField.name.toLowerCase();
							updatedState.haserror = true;
						}
						break;
				}

				updatedState.form2[f] = updatedField;

			}

			this.setState(updatedState);

			if(updatedState.haserror) {
				this.setState({processing: false});
				return false;
			}

			engine.post('/account/reset-password/', {step: 2, c: this.state.form2.code.value, p: this.state.form2.password.value})
				.then(packet => {
					if(packet.data.result) {
						this.setState({...this.state, processing: false, step: 3});
					}
					else {
						this.setState({...this.state, processing: false, result: -1, message: packet.data.response});
					}
				})
				.catch(error => {
					console.log(error);
					this.setState({...this.state, processing: false, result: -1, message: 'Sorry, an unexpected error occured.'});
				});

		}

	}


	render() {

		let fields = null;
		let top_note = null;

		let root_classes = 'account-form';
		if(this.props.flair) root_classes += ' account-form--' + this.props.flair;

		if(this.state.step === 1) {
			fields = Object.keys(this.state.form1)
				.map(field => {

					let classes = 'account-form__field';
					let errorLine = null;

					if(this.state.form1[field].error && this.state.form1[field].errormsg !== '') {
						classes += ' account-form__field--has-error';
						errorLine = <span className='account-form__field__error'>{this.state.form1[field].errormsg}</span>;
					}

					return (
						<li key={field} className={classes}>
							<StandardField id={field} f={this.state.form1[field]} handler={(event) => this.steFieldChanged1(event,field)}
								kbhandler={(event) => this.steKeyboardAction(event,field)} />
							{errorLine}
						</li>
					);
				});
		}
		else if(this.state.step === 2) {
			fields = Object.keys(this.state.form2)
				.map(field => {

					let classes = 'account-form__field';
					let errorLine = null;

					if(this.state.form2[field].error && this.state.form2[field].errormsg !== '') {
						classes += ' account-form__field--has-error';
						errorLine = <span className='account-form__field__error'>{this.state.form2[field].errormsg}</span>;
					}

					return (
						<li key={field} className={classes}>
							<StandardField id={field} f={this.state.form2[field]} handler={(event) => this.steFieldChanged2(event,field)}
								kbhandler={(event) => this.steKeyboardAction(event,field)} />
							{errorLine}
						</li>
					);
				});
			top_note = <p className='account-form__callout'>A reset code has been sent to your email address. Enter it below along with your new password.</p>;
		}
		else if(this.state.step === 3) {
			return (
				<div className={root_classes}>
					<h5 className='account-form__title'>Reset Password</h5>
					<div className='account-form__control'>
						<p className='account-form__control__line account-form__control__line--positive'>Your password has been successfully changed.</p>
						<p className='account-form__control__line'><NavLink to='/dashboard'>Go to dashboard</NavLink></p>
					</div>
				</div>
			);
		}

		let button = <div className='account-form__control__line'><button className='btn btn--full' onClick={this.submit}>Submit</button></div>;
		if(this.state.processing) button = <div className='account-form__control__line'><Processing /></div>;
		else if(this.state.result > 0) button = null;

		let serverResponse = null;
		if(this.state.result !== 0) {
			let srClass = 'account-form__control__line';
			if(this.state.result > 0) srClass += ' account-form__control__line--positive';
			if(this.state.result < 0) srClass += ' account-form__control__line--negative';
			serverResponse = <p className={srClass}>{this.state.message}</p>;
		}

		let sublink = <NavLink to='/'>Return home</NavLink>;
		if(this.props.loggedIn) {
			sublink = <NavLink to='/dashboard'>Return to dashboard</NavLink>
		}

		return (
			<div className={root_classes}>
				<h5 className='account-form__title'>Reset Password</h5>
				{top_note}
				<ul className='account-form__fields'>
					{fields}
				</ul>
				<div className='account-form__control'>
					{button}
					{serverResponse}
					<p className='account-form__control__line'>{sublink}</p>
				</div>
			</div>
		);
	}

}


export default PasswordForm;


// WEBPACK FOOTER //
// ./src/Blocks/PasswordForm.js